import React from "react";
import { useNavigate } from "react-router-dom";
import { useWeb3 } from "../../context/Web3Context";
import { truncateAddress } from "../../utils/format";
import "./TopNavbar.css";

export default function TopNavbar() {
  const { account, connectWallet, disconnect, connecting } = useWeb3();
  const navigate = useNavigate();

  return (
    <nav className="top-navbar">
      <div className="tn-brand" onClick={() => navigate(account ? "/home" : "/")}>
        <span className="tn-icon">&#9730;</span>
        <span className="tn-text">GLOBAL SHARE</span>
      </div>

      <div className="tn-right">
        {account ? (
          <div className="tn-wallet">
            <span className="tn-dot" />
            <span className="tn-addr">{truncateAddress(account)}</span>
            <button className="tn-disconnect" onClick={disconnect}>&times;</button>
          </div>
        ) : (
          <button className="tn-connect" onClick={connectWallet} disabled={connecting}>
            {connecting ? "..." : "Connect"}
          </button>
        )}
      </div>
    </nav>
  );
}
